module.exports = __webpack_public_path__ + "img/white_russian.51772e3d.jpg";